<template>
    <v-dialog v-model="isOpen" scrollable max-width="1000">
        <v-card>
            <v-card-title class="display-1 page-header">
                {{ $t("personal_terms_title") }}
            </v-card-title>
            <v-card-text>
                <p v-html="personalTerms" style="font-size: 10px; line-height: 1.5;"></p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">
                    {{ $t("close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "PersonalDataModal",
    methods: {
        close() {
            this.$store.dispatch("PERSONAL_DATA_MODAL", false);
        },
    },
    computed: {
        isOpen: {
            get() {
                return this.$store.getters.IS_PERSONAL_DATA_MODAL_OPENED;
            },
            set() {
                this.$store.dispatch("PERSONAL_DATA_MODAL", false);
            },
        },
        personalTerms() {
            return this.$store.getters.PERSONAL_DATA_MODAL_TEXT;
        },
    },
};
</script>

<style scoped>
    .v-card__text, .v-card__title {
        word-break: normal;
    }
</style>
